import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Col, Row, Button, ButtonGroup } from 'reactstrap';
import illustrator from "../../../assets/images/illustrator-1.png";
const sdkVersionDistData = require('./fakedata/sdk_version_dist.json');

const SdkVersionDistribution = () => {
    const [showAndroid, setShowAndroid] = useState(true);
    const [showIOS, setShowIOS] = useState(false);

    const androidData = sdkVersionDistData.dist.filter(item => item.osType === 'ANDROID');
    const iosData = sdkVersionDistData.dist.filter(item => item.osType === 'IOS');

    const [data, setData] = useState(androidData);

    useEffect(() => {
        if (showAndroid) {
            setData(androidData);
        } else if (showIOS) {
            setData(iosData);
        }
    }, [showAndroid, showIOS]);

    useEffect(() => {
        setData(prevData => [...prevData].sort((a, b) => (b.count / totalDevices) - (a.count / totalDevices)));
    }, [showAndroid, showIOS]);

    const totalDevices = data.reduce((sum, item) => sum + item.count, 0);

    const toggleAndroid = () => {
        setShowAndroid(true);
        setShowIOS(false);
    };

    const toggleIOS = () => {
        setShowAndroid(false);
        setShowIOS(true);
    };

    const getLastVersion = (osType) => {
        const osData = sdkVersionDistData.dist.filter(item => item.osType === osType);
        return osData.reduce((latest, item) => (latest.version > item.version ? latest : item), osData[0]).version;
    };

    const latestAndroidVersion = getLastVersion('ANDROID');
    const latestIOSVersion = getLastVersion('IOS');

    return (
        <Col xl={12} md={12}>
            <Card className="card-height-100" style={{ height: '470px' }}>
                <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1"><b>SDK Version Distribution</b></h4>
                    <ButtonGroup className="flex-shrink-0">
                        <Button
                            color={showAndroid ? 'primary' : 'secondary'}
                            onClick={toggleAndroid}
                        >
                            Android
                        </Button>
                        <Button
                            color={showIOS ? 'primary' : 'secondary'}
                            onClick={toggleIOS}
                        >
                            iOS
                        </Button>
                    </ButtonGroup>
                </CardHeader>
                <CardBody>
                    <Row className="align-items-center">
                        <Col xs={6}>
                            <h6 className="text-muted text-uppercase fw-semibold text-truncate fs-12 mb-3">Total Devices</h6>
                            <h4 className="fs-4 mb-0">{totalDevices.toLocaleString()}</h4>
                            <p className="mb-0 mt-2 text-muted"><span className="badge bg-success-subtle text-success mb-0">
                                <i className="ri-arrow-up-line align-middle"></i> Updated
                            </span> Just now</p>
                        </Col>
                        <Col xs={6}>
                            <div className="text-center">
                                <img src={illustrator} className="img-fluid" alt="" />
                            </div>
                        </Col>
                    </Row>
                    <div className="mt-3 pt-2">
                        <div className="progress progress-lg rounded-pill">
                            {data.map((item, index) => {
                                const colors = ['bg-primary', 'bg-info', 'bg-success', 'bg-warning', 'bg-danger'];
                                const color = colors[index % colors.length];
                                return (
                                    <div
                                        key={item.version}
                                        className={`progress-bar ${color}`}
                                        role="progressbar"
                                        style={{ width: `${(item.count / totalDevices) * 100}%` }}
                                        aria-valuenow={(item.count / totalDevices) * 100}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="mt-3 pt-2">
                        {data.map((item, index) => {
                            const colors = ['text-primary', 'text-info', 'text-success', 'text-warning', 'text-danger'];
                            const color = colors[index % colors.length];
                            const isLatestVersion = (item.osType === 'ANDROID' && item.version === latestAndroidVersion) ||
                                (item.osType === 'IOS' && item.version === latestIOSVersion);

                            return (
                                <div className="d-flex mb-2" key={item.version}>
                                    <div className="flex-grow-1">
                                        <p className="text-truncate text-muted fs-14 mb-0">
                                            <i className={`mdi mdi-circle align-middle ${color} me-2`}></i>
                                            {item.osType} {item.version} {isLatestVersion && <span className="badge bg-success ms-2">Latest Version</span>}
                                        </p>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <p className="mb-0">{((item.count / totalDevices) * 100).toFixed(2)}%</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default SdkVersionDistribution;
